"use client";

import { c as _c } from "react/compiler-runtime";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
import WaveDropActionsQuote from "./WaveDropActionsQuote";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import WaveDropFollowAuthor from "./WaveDropFollowAuthor";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean;
  readonly onReply: () => void;
  readonly onQuote: () => void;
  readonly onEdit?: () => void;
}
export default function WaveDropActions(t0) {
  const $ = _c(52);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onQuote,
    onEdit
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const {
    isMemesWave
  } = useSeizeSettings();
  let t2;
  if ($[0] !== drop.drop_type || $[1] !== drop.wave?.id || $[2] !== isMemesWave || $[3] !== showVoting) {
    t2 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave?.id));
    $[0] = drop.drop_type;
    $[1] = drop.wave?.id;
    $[2] = isMemesWave;
    $[3] = showVoting;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const shouldShowVoting = t2;
  let t3;
  if ($[5] !== activePartIndex || $[6] !== connectedProfile?.handle || $[7] !== drop) {
    t3 = connectedProfile?.handle !== drop.author.handle && !activePartIndex && <WaveDropFollowAuthor drop={drop} />;
    $[5] = activePartIndex;
    $[6] = connectedProfile?.handle;
    $[7] = drop;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== activePartIndex || $[10] !== drop || $[11] !== onReply) {
    t4 = <WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} />;
    $[9] = activePartIndex;
    $[10] = drop;
    $[11] = onReply;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== activePartIndex || $[14] !== drop || $[15] !== onQuote) {
    t5 = <WaveDropActionsQuote onQuote={onQuote} drop={drop} activePartIndex={activePartIndex} />;
    $[13] = activePartIndex;
    $[14] = drop;
    $[15] = onQuote;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  let t7;
  if ($[17] !== drop) {
    t6 = <WaveDropActionsCopyLink drop={drop} />;
    t7 = <WaveDropActionsOpen drop={drop} />;
    $[17] = drop;
    $[18] = t6;
    $[19] = t7;
  } else {
    t6 = $[18];
    t7 = $[19];
  }
  let t8;
  if ($[20] !== drop.id || $[21] !== drop.parts) {
    bb0: {
      const media = drop.parts?.at(0)?.media?.at(0);
      const url = media?.url;
      if (!url) {
        t8 = null;
        break bb0;
      }
      const info = getFileInfoFromUrl(url);
      if (!info) {
        t8 = null;
        break bb0;
      }
      const t9 = `download-media-${drop.id}`;
      let t10;
      if ($[23] !== info.extension || $[24] !== info.name || $[25] !== t9 || $[26] !== url) {
        t10 = <WaveDropActionsDownload href={url} name={info.name} extension={info.extension} tooltipId={t9} />;
        $[23] = info.extension;
        $[24] = info.name;
        $[25] = t9;
        $[26] = url;
        $[27] = t10;
      } else {
        t10 = $[27];
      }
      t8 = t10;
    }
    $[20] = drop.id;
    $[21] = drop.parts;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[28] !== drop || $[29] !== onEdit) {
    t9 = onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />;
    $[28] = drop;
    $[29] = onEdit;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== canDelete || $[32] !== drop) {
    t10 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[31] = canDelete;
    $[32] = drop;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== drop) {
    t11 = <WaveDropActionsAddReaction drop={drop} />;
    $[34] = drop;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t12 = <div className="tw-h-8 tw-flex tw-items-center tw-shadow tw-bg-iron-950 tw-ring-1 tw-ring-iron-800 tw-ring-inset tw-rounded-lg">{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== drop || $[47] !== shouldShowVoting) {
    t13 = shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[46] = drop;
    $[47] = shouldShowVoting;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== t12 || $[50] !== t13) {
    t14 = <div className="tw-absolute tw-z-20 tw-right-2 tw-top-0 group-hover:tw-opacity-100 tw-opacity-0 tw-transition-opacity tw-duration-200 tw-ease-in-out"><div className="tw-flex tw-items-center tw-gap-x-2">{t12}{t13}</div></div>;
    $[49] = t12;
    $[50] = t13;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  return t14;
}